export default __webpack_public_path__ + "static/media/HR-partner.66462f9c.png";